export default "__VITE_ASSET__nG5KpJB2__"